/* RESPONSIBLE TEAM: team-app-security */
import Model, { attr } from '@ember-data/model';

export default class SamlAuthModel extends Model {
  @attr('string') appName;
}
